import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';

//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//window.JSZip = jsZip;




const  ProcessedOperationsDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = t('workOrder.label.processedOperations');

   const clickHandler = (row) => {
            //row.target.id      
            if(typeof(row.target.id) !== 'undefined' && row.target.id != null){            
                props.modalCallback(true,row.target.id);  
            }
   
    };

   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('workOrder.label.workOrderNbr'), data: "workOrder.nbr", sortable: true, selector: "workOrder.nbr"},           
            { name: t('workOrder.label.operation'), data: "workOrderItem.name", sortable: true, selector: "workOrderItem.name", minWidth: '250px'},                                
            { name: t('workOrder.label.numberShort'), data: "workOrderItem.nbr", sortable: true, selector: "workOrderItem.nbr" },     
            { name: t('workOrder.label.pcsOrd'), data: "workOrder.qtyOrd", sortable: true, selector: "workOrder.qtyOrd"},
            { name: t('workOrder.label.pcsOk'), data: "qtyOk", sortable: true, selector: "qtyOk"},
            { name: t('workOrder.label.pcsNok'), data: "qtyNok", sortable: true, selector: "qtyNok"},
            { name: t('workOrder.label.durationMachine'), data: "durationMachine", sortable: true, selector: "durationMachine"},
            { name: t('workOrder.label.durationOperator'), data: "durationOperator", sortable: true, selector: "durationOperator"}
          
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('workOrder.label.workOrderNbr'), data: "workOrder.nbr",  orderable: true, searchable: true, search: {value: '',regex: false}},          
        { name: t('workOrder.label.operation'), data: "workOrderItem.name",  orderable: true, searchable: true, search: {value: '',regex: false}},       
        { name: t('workOrder.label.numberShort'), data: "workOrderItem.nbr",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.pcsOrd'), data: "workOrder.qtyOrd",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.pcsOk'), data: "qtyOk",  orderable: true, searchable: true, search: {value: '',regex: false}},        
        { name: t('workOrder.label.pcsNok'), data: "qtyNok",  orderable: true, searchable: true, search: {value: '',regex: false}},
        { name: t('workOrder.label.durationMachine'), data: "durationMachine",  orderable: true, searchable: true, search: {value: '',regex: false}},             
        { name: t('workOrder.label.durationOperator'), data: "durationOperator",  orderable: true, searchable: true, search: {value: '',regex: false}}  
     
    ];        
    const url = RestService.getBaseURL()+"workOrder/getProcessOperationList?id="+props.selectedRecord;  
    const urlExcel = RestService.getBaseURL()+"workOrder/getExcelProcessOperationList?id="+props.selectedRecord;          
 
    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
     
   
   
        return (
          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
                checkTime={props.checkTime}
            />
         
        );
   

 
};


export default ProcessedOperationsDatatable;

